import { render, staticRenderFns } from "./OptionListView.vue?vue&type=template&id=31522835"
import script from "./OptionListView.vue?vue&type=script&lang=js"
export * from "./OptionListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports